import type { TFunction } from 'i18next';
import { headingStyle } from './surveyLogic';

interface Props {
  storeName: string;
  logo: string | null;
  intro: string;
  t: TFunction;
  lang: string;
}

/** SC-1752 — opening screen. The « Commencer » button lives in the page's fixed action bar. */
export default function SurveyIntro({ storeName, logo, intro, t, lang }: Props) {
  return (
    <section className="flex flex-col items-center text-center gap-3 pt-2">
      {logo && <img src={logo} alt="" className="h-16 max-w-[60%] object-contain" />}
      <h1 className="font-display text-3xl text-ink m-0" style={headingStyle(lang)}>{t('survey.title')}</h1>
      <p className="font-mono text-sm text-ink-mute m-0">{storeName}</p>
      {intro && <p className="font-mono text-base text-ink whitespace-pre-line">{intro}</p>}
      <p className="font-mono text-sm text-ink-mute">{t('survey.anonymous')}</p>
    </section>
  );
}
